setMenuDataProcessing